const AUTH_FAILED = (state, { error }) => ({
  ...state,
  error,
  statusKnown: true
});

export const AUTH_LOGIN_FAILED = AUTH_FAILED;
export const AUTH_GET_USER_FAILED = AUTH_FAILED;

export const AUTH_SET_CURRENT_USER = (state, { brandNew, user }) => ({
  ...state,
  user: (user && { ...(!brandNew && state && state.user), ...user }) || null,
  error: null,
  statusKnown: true
});

export const AUTH_UPDATE_CURRENT_USER = (state, { updates }) => ({
  ...state,
  user: {
    ...(state && state.user),
    ...updates
  },
  statusKnown: true
});

export const AUTH_THIRD_PARTY_INTEGRATIONS = (state, { enableGlia, liveEngageKey }) => ({
  ...state,
  liveEngageKey,
  enableGlia
});